import React from 'react';
import { NavLink } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

const Footer = (props) => {
  const history = useHistory(); // useHistory hook'unu burada kullanın

  const handleLinkClick = () => {
    window.scrollTo(0, 0);
  };
    return (
        <section className={"pb-4 " + (props.type !== 'contact' ? "mt__10" : "")}>
            <div className="container">
                <div className="row">
                    <div className="col-md-3 mb-4 mb-md-0">
                        <h3 className="semi-bold font__size--24 text__24-1024 color__black">Eymen<span className="color__orange">Telçit</span></h3>
                        <p className="normal font__size--16 text__16-1024 roboto color__gray-1">27 Yıllık Tecrübe</p>
                    </div>
                    <div className="col-6 col-md-2 mb-4 mb-md-0">
                        <h5 className="semi-bold font__size--14 text__14-1024 text-uppercase mb-3">Eymen Tel Çit</h5>

                        <ul className="wrapper__list-footer">
                            <li><NavLink
                                to="/" className="semi-bold font__size--14 text__14-1024 color__black text-uppercase opacity__7 hover" onClick={handleLinkClick}>Anasayfa</NavLink></li>
                            <li><NavLink
                                to="/hakkimizda" className="semi-bold font__size--14 text__14-1024 color__black text-uppercase opacity__7 hover" onClick={handleLinkClick}>HAKKIMIZDA</NavLink></li>

                            <li><NavLink
                                to="/servislerimiz" className="semi-bold font__size--14 text__14-1024 color__black text-uppercase opacity__7 hover" onClick={handleLinkClick}>SERVİSLERİMİZ</NavLink></li>
                            <li><NavLink
                                to="/referanslarimiz" className="semi-bold font__size--14 text__14-1024 color__black text-uppercase opacity__7 hover" onClick={handleLinkClick}>REFERANSLARIMIZ</NavLink></li>
                            <li><NavLink
                                to="/iletisim" className="semi-bold font__size--14 text__14-1024 color__black text-uppercase opacity__7 hover" onClick={handleLinkClick}>İLETİŞİM</NavLink></li>
                        </ul>
                    </div>
                    <div className="col-6 col-md-3 mb-4 mb-md-0">
                        <h5 className="semi-bold font__size--14 text__14-1024 text-uppercase mb-3">BİZİ SOSYAL MEDYADAN TAKİP EDİN</h5>

                        <div className="d-flex align-items-center">
                            <a href="https://www.facebook.com/eymentelcit/">
                                <img src="./../images/FB.png" alt="" />
                            </a>
                            <a href="https://www.instagram.com/eymentel_cit_sistemleri/" className="mx-3">
                                <img src="./../images/IG.png" alt="" />
                            </a>
                            <a href="https://api.whatsapp.com/send/?phone=905436241088&text=Merhabalar&type=phone_number&app_absent=0">
                                <img src="./../images/WA.png" alt="" />
                            </a>
                            
                        </div>

                        <div className="mt-5">
                            <h5 className="semi-bold font__size--14 text__14-1024 text-uppercase mb-3">İletişim</h5>
                            <div className="d-flex align-items-center mb-3">
                                <img src="./../images/Message.png" alt="" />
                                <span className="semi-bold font__size--14 text__14-1024 text-uppercase ml-2">info@eymentelcit.com.tr</span>
                            </div>
                            <div className="d-flex align-items-center">
                                <img src="./../images/Call.png" alt="" />
                                <span className="semi-bold font__size--14 text__14-1024 text-uppercase ml-2">+90 543 624 10 88</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="text-center normal roboto font__size--16 text__16-1024 color__gray-1 mt-5">
                    Copyright eymentelcit. 2022 All Right Reserved Project By Iperdolphin.
                </div>
            </div>
        </section>
    );
};

export default Footer;
